<template>
  <navbar navbar-menu-classes="navbar-right" v-model="showMenu">
    <div class="navbar-wrapper">
      <a class="navbar-brand" href="#"></a>
    </div>
    <template slot="navbar-menu">
      <router-link v-if="$route.name !== link.routeName"
                   :to="{ name: link.routeName}"
                   class="nav-item"
                   tag="li"
                   v-for="(link, i) in links"
                   :key="`link_${i}`">
        <a class="nav-link">
          <i class="nc-icon" :class="link.icon"></i> {{ link.text }}
        </a>
      </router-link>
    </template>
  </navbar>
</template>

<script>
  import { Navbar } from 'src/components/UIComponents'

  export default {
    name: 'main-navbar',
    components: {
      Navbar
    },
    data () {
      return {
        showMenu: false,
        links: [
          { text: 'Login', icon: 'nc-tap-01', routeName: 'Login' }
        ]
      }
    }
  }
</script>

